// ============================================
// Constants — mirrors Unity Constants.cs
// ============================================

export const Stats = {
    ENERGY: 'Energy',
    AROUSAL: 'Arousal',
    FEMININITY: 'Femininity',
    SUBMISSIVENESS: 'Submissiveness',
    MONEY: 'Money',
    SHAME: 'Shame',
    MASCULINITY: 'Masculinity', // computed: 100 - Femininity
};

export const EquipSlots = {
    HEAD: 0,
    UPPER: 1,
    LOWER: 2,
    BRA: 3,
    UNDERWEAR: 4,
    FEET: 5,
    ACCESSORY: 6,
    ITEM: 7,
    FRONT: 8,
    BACK: 9,
    LEGWEAR: 10,
    PIERCING: 11,
    ACCESSORY2: 12,
    ACCESSORY3: 13,
    ACCESSORY4: 14,
    PIERCING2: 15,
    PIERCING3: 16,
    ACCESSORY5: 17,
    ACCESSORY6: 18,
    COSMETIC: 19,
    COSMETIC2: 20,
    COSMETIC3: 21,
};

export const EquipSlotNames = [
    'Head', 'Upper', 'Lower', 'Bra', 'Underwear',
    'Feet', 'Accessory', 'Item', 'Front', 'Back',
    'Legwear', 'Piercing', 'Accessory2', 'Accessory3', 'Accessory4',
    'Piercing2', 'Piercing3', 'Accessory5', 'Accessory6',
    // Cosmetics (perfume / lip gloss / nail polish) — their own multi-slot so
    // all can be worn together instead of fighting over the single Item slot.
    // MUST stay appended at the end: EquipSlots indices + saved equip maps are
    // positional-stable only if existing slots keep their index. (0.3.0.8)
    'Cosmetic', 'Cosmetic2', 'Cosmetic3'
];

// Multi-slot groups: items auto-route to first empty slot in their group
export const ACCESSORY_SLOTS = ['Accessory', 'Accessory2', 'Accessory3', 'Accessory4',
                                'Accessory5', 'Accessory6'];
export const PIERCING_SLOTS = ['Piercing', 'Piercing2', 'Piercing3'];
export const COSMETIC_SLOTS = ['Cosmetic', 'Cosmetic2', 'Cosmetic3'];

/** All multi-slot mappings: base slot name → slot array */
export const MULTI_SLOT_MAP = {
    'Accessory': ACCESSORY_SLOTS,
    'Piercing': PIERCING_SLOTS,
    'Cosmetic': COSMETIC_SLOTS,
};

export const Flags = {
    EQUIPPED_PANTIES: 'EquippedPanties',
    EQUIPPED_FEMININE: 'EquippedFeminine',
    EQUIPPED_CUFFS: 'EquippedCuffs',
    EQUIPPED_HEELS: 'EquippedHeels',
    EQUIPPED_NIPPLE_CLAMPS: 'EquippedNippleClamps',
    EQUIPPED_WAIST_TRAINER: 'EquippedWaistTrainer',
    HYPNO_UNLOCKED: 'hypno_content_unlocked',
    OWNS_CHASTITY: 'owns_chastity',
    OWNS_PLUG: 'owns_plug',
    WEARING_CHASTITY: 'wearing_chastity',
    WEARING_PLUG: 'wearing_plug',
    IS_DRESSED: 'is_dressed',
    IS_DIRTY: 'is_dirty',
    IS_DRUNK: 'is_drunk',
    IS_TIRED: 'is_tired',
    HAS_MAKEUP: 'has_makeup_on',
    IS_VISIBLY_AROUSED: 'is_visibly_aroused',
    WEARING_WIG: 'wearing_wig',
    HAS_LONG_HAIR: 'has_long_hair',
    WEARING_VIB: 'wearing_vib',
    HAS_VISIBLE_BREASTS: 'has_visible_breasts',
};

export const Location = {
    GLOBAL: 'Global',
    HOME: 'Home',
    BAR: 'Bar',
    OFFICE: 'Office',
    UNIVERSITY: 'University',
    PC: 'PC',
    MALL: 'Mall',
    PARK: 'Park',
    OUTSIDE: 'Outside',
    SALON: 'Salon',
    BEACH: 'Beach',
    CLUB: 'Club',
    GYM: 'Gym',
    CLINIC: 'Clinic',
    SPA: 'Spa',
    TATTOO: 'Tattoo',
    CABARET: 'Cabaret',
};

export const InkTags = {
    IMG: 'img',
    GIF: 'gif',
    INFO: 'info',
    CHAR: 'char',
    UI: 'ui',
    ITEM: 'item',
    DELAY: 'delay',
    QUICK_TRAVEL: 'quicktravelpossible',
    BGM: 'bgm',
    SFX: 'sfx',
    AMBIENT: 'ambient',
    ACHIEVEMENT: 'achievement',
    STATS: 'stats',
    SMS: 'sms',
    MMS: 'mms',
    SMS_FILE: 'smsfile',
    SMS_REPLY: 'smsreply',
    DISABLED: 'disabled',
    REQ: 'req',
    MAX: 'max',
    ENERGY: 'energy',
    TIME: 'time',
    FEM: 'fem',
    SUB: 'sub',
    SHAME: 'shame',
    AROUSAL_TAG: 'arousal',
    COLOR: 'color',
    RETURN: 'return',
    BREAK: 'break',
    ID: 'id',
    CHOICEIMG: 'choiceimg',
    HOTSPOT: 'hotspot',
    TUTORIAL: 'tutorial',
    MONOLOGUE: 'monologue',
    SHOT: 'shot',
    CHAT: 'chat',           // 0.2.6 streaming rework — #chat:pool emits a state-aware reactive line
};

export const UITags = {
    SHOP_LINGERIE: 'shop_lingerie',
    SHOP_ADULT: 'shop_adult',
    SHOP_MENS: 'shop_mens',
    SHOP_WOMENS: 'shop_womens_clothing',
    SHOP_PHARMACY: 'shop_pharmacy',
    SHOP_APARTMENT: 'shop_apartment',
    SHOP_STREAM: 'shop_stream',
    SHOP_TATTOO: 'shop_tattoo',
    SHOP_TATTOO_BACKROOM: 'shop_tattoo_backroom',
    SHOP_FETISH: 'shop_fetish',
    STREAMING: 'streaming',
    STREAMING_HUB: 'streaming_hub',
    MAIN_MENU: 'mainmenu',
    WARDROBE: 'wardrobe',
    DESKTOP: 'desktop',
    COMPUTER: 'computer',
    PORN_CATEGORIES: 'porn_categories',
    PLANNER: 'planner',
};

export const TimeSlotNames = ['Morning', 'Lunch', 'Evening', 'Night'];

export const IMAGE_FOLDERS = [
    'Apartment', 'Bar', 'Beach', 'Boyfriend', 'Cabaret', 'Characters', 'Clinic',
    'Club', 'Computer', 'Construction', 'Dare', 'Dreams', 'Endgame', 'Girlfriend',
    'Gym', 'Items', 'Locations', 'Maid', 'Mall', 'Milestones',
    'Office', 'Park', 'Phone', 'Photographer', 'Portraits', 'Prologue',
    'Resort', 'Salon', 'Sarah', 'ShopEvents', 'SMS', 'Spa', 'SugarDaddy', 'System',
    'UI', 'University', 'FreeUse', 'Minigame', 'patreon', 'doll'
];

export const SPEAKER_DISPLAY_NAMES = {
    'master': null,    // dynamic from MasterName
    'girlfriend': null, // dynamic from GirlfriendName
    'info': null,       // reserved for info text
    'player': null,     // dynamic from PlayerName
    'malik': 'Malik',
    'mercer': 'Dr. Mercer',
    'marco': 'Marco',
    'diego': 'DJ Diego',
    'lily': 'Lily',
    'victor': 'Victor Ashford',
    'jake': 'Jake',
    'tyler': 'Tyler',
    'kai': 'Kai',
    'owen': 'Owen',
    'raven': 'Raven',
    'eloise': 'Eloïse',
    'sasha': 'Sasha',
    'dante': 'Dante',
    'iris': 'Iris',
    'bouncer': 'Bouncer',
    'bartender': 'Bartender',
    'stranger': 'Stranger',
    'photographer': 'Photographer',
    'bully': 'Beach Bully',
    'sugardaddy': 'Daddy',
    'boss': 'Mr. Hartwell',
    'nurse': 'Nurse',
    'receptionist': 'Receptionist',
    'dominic': 'Dominic',
    'camille': 'Camille',
};
